var PvpQuitPanel = xClass("PvpQuitPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_pvp3_panel_ticket.csb")
})

PvpQuitPanel.show = function (logic, isEnemeyQuit, callback) {
    var panel = PvpQuitPanel.create(logic, isEnemeyQuit, callback);
    panel.popup();
    return panel;
}

var PvpQuitPanelEvent = table(
    [1, "QuitGame", "QUITPANELEVENT.QUITGAME"],
    [1, "ReplayGame", "QUITPANELEVENT.REPLAYGAME"],
    [1, "Close", "QUITPANELEVENT.CLOSE"]
)

PvpQuitPanel.prototype.ctor = function (logic, isEnemeyQuit, callback) {
    var self = this;
    BasePanel.prototype.ctor.call(self);
    self.pvpLogic = logic;
    self.callback = callback;
    var txt1 = self.getChildByName("txt");
    txt1.y -= 20;
    txt1.x -= 20;
    txt1.width += 50;
    var txt2 = self.getChildByName("btn_free").getChildByName("label");
    var txt3 = self.getChildByName("btn_coins").getChildByName("label");
    if (isEnemeyQuit){
        txt1.width += 30;
        txt1.height += 60;
        txt1.y += 30;
        txt1.x -= 10;
        txt1.setString(getText("pvp.another.quit.text"));
        txt2.setString(getText("pvp.another.quit.button2"));
        txt2.x += 48;
        txt3.setString(getText("pvp.another.quit.button1"));
        txt3.x += 43;
    }else{
        txt1.setString(getText("pvp.quit.text"));
        txt2.setString(getText("pvp.quit.button2"));
        txt2.x += 48;
        txt3.setString(getText("pvp.quit.button1"));
        txt3.x += 43;
    }

    quickBuildUIBUtton(self.getChildByName("btn_coins"), () => {
        self.onClose();
        self.callback();
    })
    quickBuildUIBUtton(self.getChildByName("btn_free"), () => {
        self.dispatchEvent(table([1, "name", PvpQuitPanelEvent.Close]))
        self.onClose();
    })
}

PvpQuitPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()*1.1
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var vSize = cc.Director.getInstance().getVisibleSize();
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(40, 950 + dH/2));
    var pos_O = cc.p(vSize.width / 2, vSize.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}
module.exports = table([0, PvpQuitPanel], [0, PvpQuitPanelEvent])